export default __webpack_public_path__ + "static/media/logos.76661062.svg";